import React from "react";
import styles from "./Footer.module.scss";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        &#169; {currentYear} Sharon Wang. All rights reserved.
        <div className={styles.assetCredit}>
          Earth texture by{" "}
          <a
            href="https://www.solarsystemscope.com/textures/download/8k_earth_daymap.jpg"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Solar System Scope textures (opens in new tab)"
          >
            Solar System Scope
          </a>{" "}
          (
          <a
            href="https://creativecommons.org/licenses/by/4.0/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Creative Commons Attribution 4.0 license (opens in new tab)"
          >
            CC BY 4.0
          </a>
          )
          <br />
          Skill icons by{" "}
          <a
            href="https://github.com/tandpfun/skill-icons"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Skill Icons repository (opens in new tab)"
          >
            Skill Icons
          </a>{" "}
          (
          <a
            href="https://opensource.org/licenses/MIT"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="MIT License (opens in new tab)"
          >
            MIT License
          </a>
          )
        </div>
      </div>
    </footer>
  );
};

export default Footer;
